"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Target = exports.targetsAreProfessions = exports.POPULATION_CATEGORIES_FLAT = exports.POPULATION_CATEGORIES = exports.DELAY_REASONS = exports.TARGET_ACTORS = exports.TARGET_TYPES = exports.TARGET_STATUSES = exports.TargetGoal = void 0;
class TargetGoal {
    constructor(data) {
        this.views = 0;
        this.days = 0;
        this.shipments = 0;
        if (data) {
            const parsedData = (typeof data === "string") ? JSON.parse(data) : data;
            this.views = parsedData.views;
            this.days = parsedData.days;
            this.shipments = parsedData.shipments;
        }
    }
    getType() {
        if (this.views) {
            return 'views';
        }
        else if (this.days) {
            return 'days';
        }
        else {
            return 'shipments';
        }
    }
    getValue() {
        return this.views || this.days || this.shipments;
    }
}
exports.TargetGoal = TargetGoal;
exports.TARGET_STATUSES = [
    "1. offline - préparation",
    "2. en ligne",
    "3. stats à sortir",
    "3.1 Urgent - Stats à sortir",
    "3.2 stats intermédiaires",
    "4. feedback à préparer",
    "5. feedback prêt",
    "6. feedback réalisé",
    "7. annulé"
];
exports.TARGET_TYPES = [
    "post",
    "video",
    "quiz",
    "search",
    "story",
    "story video",
    "contenu additionel",
    "notification",
    "mise en avant",
    "nl hebdo",
    "référencement",
    "sondage",
    "emailling dédié",
    "medacademy",
    "conseil associé",
    "datas",
    "flash notif"
];
exports.TARGET_ACTORS = [
    "Banques et assurances",
    "DM",
    "Laboratoire",
    "Santé animale",
    "Start-up"
];
exports.DELAY_REASONS = [
    '360 medics - délai vente/diffusion trop court',
    '360 medics - retard de production en interne',
    '360 medics - retard prestataire',
    'Clients - manque de réactivité',
    'Clients - validation réglementaire',
    'Clients - non-disponibilité du contenu',
    'Clients - + de 3 allers-retours'
];
exports.POPULATION_CATEGORIES = {
    "professions": {
        "2": "Médecin",
        "8": "Autre profession de santé",
        "4": "Pharmacien",
        "3": "Infirmier/Infirmière",
        "6": "Sage Femme",
        "7": "Patient",
        "9": "Kinésithérapeute",
        "5": "Dentiste",
        "10": "Préparateur en pharmacie",
        "12": "Pédicure - Podologue",
        "11": "Secrétaire médicale"
    },
    "specialties": {
        "26": "Médecine générale",
        "10": "Oncologie médicale",
        "31": "Oncologie radiothérapie",
        "45": "Médecine d'urgence",
        "30": "Onco-hématologie",
        "23": "Rhumatologie",
        "42": "Gériatrie",
        "12": "Dermatologie et vénérologie",
        "4": "Chirurgie générale",
        "46": "Autre",
        "32": "Gynécologie-obstétrique",
        "27": "Pédiatrie",
        "28": "Psychiatrie",
        "13": "Hépato-gastro-entérologie",
        "21": "Pneumologie",
        "37": "Chirurgie plastique reconstructrice et esthétique",
        "16": "Médecine nucléaire",
        "3": "Oto-rhino-laryngologie et chirurgie cervico-faciale",
        "39": "Urologie",
        "29": "Santé publique et médecine sociale",
        "5": "Neurochirurgie",
        "22": "Radio-diagnostic et imagerie médicale",
        "41": "Chirurgie viscérale et digestive",
        "1": "Anesthésie-réanimation",
        "8": "Anatomie et cytologie pathologique",
        "43": "Hématologie",
        "14": "Génétique médicale",
        "11": "Cardiologie et maladies vasculaires",
        "15": "Médecine interne",
        "24": "Biologie médicale",
        "36": "Chirurgie orthopédique et traumatologique",
        "17": "Médecine physique et de réadaptation",
        "18": "Néphrologie",
        "34": "Chirurgie maxillo-faciale",
        "6": "Chirurgie orale",
        "2": "Ophtalmologie",
        "47": "Médecine vasculaire",
        "25": "Médecine et Santé au travail",
        "40": "Chirurgie vasculaire",
        "19": "Neurologie",
        "9": "Endocrinologie-diabétologie-nutrition",
        "7": "Gynécologie médicale",
        "44": "Maladies infectieuses et tropicales",
        "38": "Chirurgie thoracique et cardio-vasculaire",
        "33": "Chirurgie pédiatrique",
        "35": "Chirurgie de la face et du cou",
        "50": "Médecine intensive-réanimation",
        "20": "Pathologies cardio-vasculaires",
        "51": "Médecine légale et expertises médicales",
        "48": "Allergologie",
        "53": "Sport and exercise medicine",
    }
};
exports.POPULATION_CATEGORIES_FLAT = [
    ...['Toute la base'],
    ...Object.values(exports.POPULATION_CATEGORIES.professions),
    ...Object.values(exports.POPULATION_CATEGORIES.specialties)
];
function targetsAreProfessions(populationCategory) {
    if (Object.values(exports.POPULATION_CATEGORIES.professions).includes(populationCategory[0])) {
        return true;
    }
    else {
        return false;
    }
}
exports.targetsAreProfessions = targetsAreProfessions;
class Target {
    constructor(data) {
        this.id = null;
        this.projectId = null;
        this.projectName = null;
        this.advertId = null;
        this.advertSource = null;
        this.actionCode = null;
        this.populationCategory = null;
        this.populationSample = null;
        this.populationSize = 0;
        this.goal = new TargetGoal();
        this.startDate = null;
        this.endDate = null;
        this.checkDate = null;
        this.revenue = null;
        this.status = exports.TARGET_STATUSES[0];
        this.type = null;
        this.quotationSignedMonth = null;
        this.initialQuotationDate = null;
        this.releaseDateDiff = null;
        this.revenueDelayImpact = null;
        this.actor = null;
        this.toolId = null;
        this.clientName = null;
        this.delayReason = null;
        this.promoteInSearch = false;
        if (data) {
            this.hydrate(data);
        }
    }
    hydrate(data) {
        this.id = data.id || null;
        this.projectId = data.projectId || null;
        this.projectName = data.projectName || null;
        this.advertId = data.advertId || null;
        this.advertSource = data.advertSource || null;
        this.actionCode = data.actionCode || null;
        this.populationSample = data.populationSample || null;
        this.populationSize = data.populationSize || null;
        this.populationCategory = data.populationCategory || null;
        this.goal = new TargetGoal(data.goal) || new TargetGoal();
        this.startDate = data.startDate || null;
        this.endDate = data.endDate || null;
        this.checkDate = data.checkDate || null;
        this.revenue = data.revenue || null;
        this.status = data.status || exports.TARGET_STATUSES[0];
        this.type = data.type || null;
        this.quotationSignedMonth = data.quotationSignedMonth || null;
        this.initialQuotationDate = data.initialQuotationDate || null;
        this.releaseDateDiff = data.releaseDateDiff || null;
        this.revenueDelayImpact = data.revenueDelayImpact || null;
        this.actor = data.actor || null;
        this.toolId = data.toolId || null;
        this.clientName = data.clientName || null;
        this.isProjectCommented = data.isProjectCommented || false;
        this.delayReason = data.delayReason || null;
        this.promoteInSearch = Boolean(data.promoteInSearch) || false;
        if (typeof data._comment !== "undefined" && data._comment !== null) {
            this._comment = data._comment;
        }
    }
}
exports.Target = Target;
//# sourceMappingURL=Target.js.map